import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/cba/bx_font_o.png'
import _imports_1 from '../../assets/cba/sj.png'
import _imports_2 from '../../assets/cba/time.png'


const _hoisted_1 = { class: "cbaPage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "banner_img_cba" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"margin":"0px 0px 0px 0px"},
    alt: ""
  })
], -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "per_banner" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "per_info" }
const _hoisted_7 = { class: "mtb3" }
const _hoisted_8 = { class: "items-center justify-center dateTime mtb3" }
const _hoisted_9 = { class: "contentFont items-center justify-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"15%"}
}, null, -1)
const _hoisted_11 = { class: "zjFont" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("中奖名额:")
const _hoisted_13 = { class: "zjNumber" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "kjTime"
}, null, -1)
const _hoisted_15 = { class: "zjTime" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 点击查看 ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "中奖记录", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
      onRefresh: _ctx.onRefresh,
      style: {"overflow-y":"auto","height":"63vh"}
    }, {
      default: _withCtx(() => [
        (_ctx.cdaLists.length == 0)
          ? (_openBlock(), _createBlock(_component_van_empty, {
              key: 0,
              style: {"margin":"20% 0"},
              description: "暂无记录"
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cdaLists, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["cbaProduct", idx == 0 ? 'mt10' : 'm10']),
                key: idx
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["cba_per_pro firs", idx == 0 ? 'firs' : 'other']),
                  onClick: ($event: any) => (_ctx.jumpInfo(item))
                }, [
                  _createVNode(_component_van_row, { class: "items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, { span: "8" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("img", {
                              src: item.activityImg,
                              alt: ""
                            }, null, 8, _hoisted_5)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_van_col, { span: "16" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("span", null, _toDisplayString(item.projectName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, " 报名时间:" + _toDisplayString(item.startTime) + " ~ " + _toDisplayString(item.endTime), 1),
                            _createVNode(_component_van_row, { class: "d-flex mtb3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "16",
                                  class: "lineBg"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, [
                                      _createTextVNode(" 已报名人数:" + _toDisplayString(item.totalNum) + " ", 1),
                                      _hoisted_10
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_van_col, { span: "8" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                      _hoisted_12,
                                      _createElementVNode("span", _hoisted_13, _toDisplayString(item.quantity), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_van_row, { class: "items-end justify-center mtb3" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "14",
                                  style: {"line-height":"10px"}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_14,
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.openTime), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_van_col, { span: "10" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (_ctx.jumpInfo(item)),
                                      class: _normalizeClass(["btnJump items-center justify-center", item.signUpStatus == 0 ? 'btn_blue' : item.signUpStatus == 1 ? 'btn_gray' : item.signUpStatus == 2 ? 'btn_gray' : 'btn_gray'])
                                    }, [
                                      _createTextVNode(_toDisplayString(item.signUpStatus == 0 ? `活动进行中` : item.signUpStatus == 1 ? `即将开始` : item.signUpStatus == 2 ?
                        `已结束` : `会员已报名`) + " ", 1),
                                      _createElementVNode("img", {
                                        src: item.signUpStatus == 0 ? _ctx.iconPointer : item.signUpStatus == 1 ? _ctx.iconTimeStart : item.signUpStatus == 2 ? _ctx.iconTimeEnd : _ctx.iconTimeEnd,
                                        class: "pointer"
                                      }, null, 8, _hoisted_17)
                                    ], 10, _hoisted_16)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ], 10, _hoisted_3)
              ], 2))
            }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createElementVNode("div", {
      class: "items-center justify-center showRecord",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goUrl && _ctx.goUrl(...args)))
    }, [
      _hoisted_18,
      _hoisted_19,
      _createVNode(_component_van_icon, { name: "arrow" })
    ])
  ]))
}